import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { useState } from "react";
import { QuantumDemandTopic } from "../../QuantumDemand.types";
import { RankBadge } from "../RankBadge";
import { SectionLabel } from "../SectionLabel";
import { SeeMoreButton } from "../SeeMoreButton";

interface RankedTopicListProps {
  title: string;
  columnLabel: string;
  topics: QuantumDemandTopic[];
  initialCount: number;
  emptyMessage: string;
}

export const RankedTopicList = ({
  title,
  columnLabel,
  topics,
  initialCount,
  emptyMessage,
}: RankedTopicListProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const mutedColor = useColorModeValue("gray.500", "gray.400");
  const dividerColor = useColorModeValue("gray.100", "gray.600");

  const visibleTopics = isExpanded ? topics : topics.slice(0, initialCount);

  return (
    <Box>
      <SectionLabel>{title}</SectionLabel>
      {topics.length === 0 ? (
        <Text fontSize="sm" color={mutedColor}>
          {emptyMessage}
        </Text>
      ) : (
        <>
          <Flex
            justifyContent="space-between"
            pb={2}
            borderBottom="1px solid"
            borderColor={dividerColor}
            fontSize="10px"
            fontWeight="bold"
            textTransform="uppercase"
            letterSpacing="0.05em"
            color={mutedColor}
          >
            <Text pl="29px">{columnLabel}</Text>
            <Text>Score</Text>
          </Flex>
          {visibleTopics.map(({ topic, score }, index) => (
            <Flex
              key={topic}
              alignItems="center"
              gap="10px"
              py={2}
              borderTop={index === 0 ? undefined : "1px solid"}
              borderColor={dividerColor}
            >
              <RankBadge rank={index + 1} />
              <Text flex={1} fontSize="13px" fontWeight="semibold">
                {topic}
              </Text>
              <Text fontFamily="mono" fontSize="13px" fontWeight="bold">
                {Math.round(score)}
              </Text>
            </Flex>
          ))}
          {topics.length > initialCount && (
            <SeeMoreButton
              isExpanded={isExpanded}
              onToggle={() => setIsExpanded((expanded) => !expanded)}
            />
          )}
        </>
      )}
    </Box>
  );
};
